var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSchedule = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,5.048a1,1,0,0,1,2,0V8a2,2,0,0,1-2,2H2A2,2,0,0,1,0,8V2A2,2,0,0,1,2,0H8a2,2,0,0,1,2,2A1,1,0,0,1,8,2H2V8H8Z",
    transform: "translate(12 12)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1,2A1,1,0,0,1,1,0H8A1,1,0,0,1,8,2Z",
    transform: "translate(12 4)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.293,1.707A1,1,0,0,1,1.707.293l3,3a1,1,0,0,1,0,1.414l-3,3A1,1,0,0,1,.293,6.293L2.586,4Z",
    transform: "translate(16 1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1,2A1,1,0,0,0,0,1,1,1,0,0,0-1,0H-8A1,1,0,0,0-9,1,1,1,0,0,0-8,2Z",
    transform: "translate(10 16)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-.293,1.707a1,1,0,0,0,0-1.414,1,1,0,0,0-1.414,0l-3,3a1,1,0,0,0,0,1.414l3,3a1,1,0,0,0,1.414,0,1,1,0,0,0,0-1.414L-2.586,4Z",
    transform: "translate(5 13)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.905,4.248a1,1,0,0,1,1.937-.5A5,5,0,1,1,7.5.67,1,1,0,1,1,6.5,2.4,2.993,2.993,0,1,0,7.905,4.248Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSchedule, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/schedule.4e7ecd2f.svg";
export { ForwardRef as ReactComponent };